import React, { Component } from "react";
import { blue700, blue600 } from "material-ui/styles/colors";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui/Paper";
import { connect } from "react-redux";
import { LBLEMPLOYESS, LBLPROJECTS } from "../../constants/labels";
import { FetchCompanyParam } from "../../actions/info/companies_info_form";
import { toggleSnackbar } from "../../actions/commons";
import SelectFieldFormat from "../../components/fields/SelectFieldFormat/SelectFieldFormat";
import SendMessageModal from "../../components/ModalSendEmail/modalSendEmail";
import ButtonBack from "../../components/fields/buttonBack/buttonBack";
import { openModalSendEmailId } from "../../components/ModalSendEmail/action";
import RaisedButton from "material-ui/RaisedButton";
import SpinnerLoading from "../SpinnerLoading/componentSpinner";
import MenuItem from "material-ui/MenuItem";
import Divider from "material-ui/Divider";
import _ from "lodash";
import AuthComponent from "../AuthComponent";
import TablePagination from "../TablePagination/tablePagination";
import TagsEmployee from "../TagsEmployee/TagsEmployee";
import ResetUsersAuth from "./resetUsersAuth";

const stylePaper = {
    marginTop: 40,
    marginBottom: 20,
};

let urlBack;

class SendMasiveEmailEmployeesFilter extends Component {
    constructor(props) {
        super(props);
        this.handleModalSendEmail = this.handleModalSendEmail.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { FetchCompanyParam, profile, params } = this.props;
        FetchCompanyParam(_.get(params, "company"));
        if (!_.isEmpty(profile)) {
            this.setState({
                isReferee: _.isEqual(_.get(profile, "role"), "referee"),
            });
        }
        urlBack = `/admin/projects/advance/${_.get(params, "profile")}/${_.get(
            params,
            "company"
        )}/`;
    }

    handleModalSendEmail() {
        const { openModalSendEmailId, selected } = this.props;
        openModalSendEmailId(selected, "employee");
    }

    render() {
        const {
            params,
            businessName,
            selected,
            textTag,
            textValueTag,
            status,
        } = this.props;
        const body = [
            {
                field: "id",
                title: "Identificación",
                filter: true,
            },
            {
                field: "name",
                title: "Nombre",
                filter: true,
            },
            {
                field: "lastName",
                title: "Apellido(s)",
                filter: true,
            },
            {
                field: "email",
                title: "Correo electrónico",
            },
            {
                field: "status",
                title: "Estado",
                order: false,
            },
        ];
        let extra = {
            project: _.get(params, "idProject"),
            status: this.state.status,
        };
        if (!_.isNull(textValueTag) && !_.isNull(textTag)) {
            extra = _.chain(extra)
                .set("textTag", textTag)
                .set("textValueTag", textValueTag)
                .value();
        }
        if (!_.isEqual(status, "all") && !_.isNull(status)) {
            extra = _.chain(extra).set("status", status).value();
        }
        return (
            <AuthComponent
                component={
                    <Row>
                        <Col xsOffset={2} xs={8}>
                            <Paper style={stylePaper}>
                                <ButtonBack
                                    url={`${urlBack}${_.get(
                                        params,
                                        "idProject"
                                    )}`}
                                />
                                <Row>
                                    <Col xs>
                                        <div
                                            style={{
                                                width: "100%",
                                                background: blue600,
                                                paddingTop: 5,
                                                paddingBottom: 5,
                                                color: "#FFF",
                                            }}
                                        >
                                            <h2
                                                style={{
                                                    textAlign: "center",
                                                    fontWeight: 400,
                                                }}
                                            >
                                                {businessName}
                                            </h2>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs>
                                        <div
                                            style={{
                                                width: "100%",
                                                background: blue700,
                                                paddingTop: 5,
                                                paddingBottom: 5,
                                                color: "#FFF",
                                            }}
                                        >
                                            <h1
                                                style={{
                                                    textAlign: "center",
                                                    fontWeight: 400,
                                                }}
                                            >{`${LBLEMPLOYESS.titleSendEmailMasive}`}</h1>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs>
                                        <TagsEmployee
                                            companyId={_.get(params, "company")}
                                            URL={`/projects/employees/status/${_.get(
                                                params,
                                                "company"
                                            )}/${_.get(params, "idProject")}`}
                                            version={2}
                                            extra={{
                                                company: _.get(
                                                    params,
                                                    "company"
                                                ),
                                                profile: _.get(
                                                    params,
                                                    "profile"
                                                ),
                                            }}
                                            filterStatus
                                            body={body}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs>
                                        <TablePagination
                                            name={"configemployeesemail"}
                                            URL={`/projects/employees/status/${_.get(
                                                params,
                                                "company"
                                            )}/${_.get(params, "idProject")}`}
                                            version={2}
                                            body={body}
                                            extra={extra}
                                            selection
                                            fieldSelection={"_id"}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs>
                                        <AuthComponent
                                            component={
                                                <RaisedButton
                                                    label={`${
                                                        LBLEMPLOYESS.buttons
                                                            .sendingBulkMail
                                                    } (${_.size(selected)})`}
                                                    secondary
                                                    style={{
                                                        margin: 20,
                                                        float: "right",
                                                    }}
                                                    disabled={
                                                        _.size(selected) === 0
                                                    }
                                                    onClick={
                                                        this
                                                            .handleModalSendEmail
                                                    }
                                                />
                                            }
                                            permission={
                                                "cgr_results_send_massive_emails"
                                            }
                                            type={"component"}
                                        />
                                        <AuthComponent
                                            component={
                                                <ResetUsersAuth
                                                    disabled={
                                                        _.size(selected) === 0
                                                    }
                                                    selected={selected}
                                                    style={{
                                                        margin: 20,
                                                        float: "right",
                                                    }}
                                                />
                                            }
                                            permission={"cgr_survey_reset_user"}
                                            type={"component"}
                                        />
                                    </Col>
                                </Row>
                            </Paper>
                            <SpinnerLoading />
                            <SendMessageModal />
                        </Col>
                    </Row>
                }
                permission={"cgr_results_send_massive_emails"}
                type={"url"}
            />
        );
    }
}

function mapStateToProps(
    { companies, login, tagsEmployee, tablePagination },
    owersProps
) {
    return {
        profile: login.get("profile"),
        businessName: _.get(companies, "company.data.businessName", ""),
        textValueTag: tagsEmployee.get("textValueTag"),
        textTag: tagsEmployee.get("textTag"),
        selected: tablePagination.get("selected"),
        status: tablePagination.get("status"),
    };
}

export default connect(mapStateToProps, {
    FetchCompanyParam,
    toggleSnackbar,
    openModalSendEmailId,
})(SendMasiveEmailEmployeesFilter);
